import { get } from 'lodash'

import { Container, getTranslatedString } from '@skinsoft/types'

export const futureLocation = (container: Container, locale: string) =>
    getTranslatedString(
        get(container, 'locationItemSchema.futureLocation.futureLocation.path'),
        locale,
    )

export const location = (container: Container, locale: string) => {
    const path = get(container, 'locationItemSchema.realTimeLocation.realTimeLocation.path', undefined)
    if(path && path.translatedString) {
        return getTranslatedString(path, locale)
    }

    return get(container, 'locationItemSchema.realTimeLocation.realTimeLocation')
}

export const typeOfContent = (container: Container) => get(container, 'containerItemDataSchema.typeOfContent')

export const itemType = (container: Container) => get(container, 'descriptionItemSchema.itemType')
